<template>

  <t-page>


    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle"
                  :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         placeholder="Nº Controle"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form">


          <t-input-code-label disable-name lot v-model="form.lotId"/>


          <t-input  class="mt-2" v-model="form.typeQualityAppraisalId" :options="typeQualityAppraisalOptions" select
                    label="Tipo de Certificado de Qualidade"/>

          <t-input-search v-model="form.issueDate" enable-range date label="Data Emissão"/>

          <t-input-person customer
                          v-model="form.customerId"/>

          <t-input-search v-model="form.groupProductId"
                          :options="groupProductOptions"
                          label="Grupo de Produtos"
                          select/>

        </t-content-header-search-default>

      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.qualityAppraisalCodeLabel" :userAuth="userAuth"
                               :id="item.qualityAppraisalNumber"
                               :path="currentPage.path"/>
        </template>

        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(issueDate)="{item}">
          {{ item.issueDate | date }}
        </template>


        <template #cell(actions)="{item}">


          <t-list-actions-default :form-path="currentPage.path" :id="item.qualityAppraisalNumber"
                                  :userAuth="userAuth">

            <b-button
                v-b-tooltip.hover.ds500 title="Laudo completo em PDF"
                @click="downloadReport(7, item.expeditionId, 'LAUDO_QUALIDADE_' + item.expeditionNumber)"
                size="sm" variant="outline">
              <b-icon-file-pdf variant="primary"></b-icon-file-pdf>
            </b-button>

          </t-list-actions-default>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import groupProductService from "@/services/modules/product/GroupProduct.service";
import typeQualityAppraisal from "@/services/modules/quality/TypeQualityAppraisal.service";

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'PolimixQualityAppraisal',
  data() {
    return {
      path: "custom/polimix/quality-appraisal", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Nº Controle"},
        {key: "lotCodeLabel", label: "Lote"},
        {key: "customer", label: "Cliente"},
        {key: "groupProduct", label: "Grupo"},
        {key: "model", label: "Modelo"},
        {key: "issueDate", label: "Data Emissão"},
        {key: "typeQualityAppraisal", label: "Tipo Certificado"},
        {key: "expeditionNumber", label: "Nº Expedição"},
        {key: "actions", label: ""},
      ],
      form: {
        lotId:0,
        customerId:0,
        groupProductId: 0,
        typeQualityAppraisalId:0,
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      groupProductOptions: [],
      typeQualityAppraisalOptions:[],
      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      //Remove busca por status do padrão, pois nesta tela não há status
      delete this.form.status

    },
    async mountedContinued() {

      await groupProductService.selectList("grouped").then((list) => {
        this.groupProductOptions = list
      }).catch(error => this.responseError(error))

      await typeQualityAppraisal.selectList().then((list) => {
        this.typeQualityAppraisalOptions = list
      }).catch(error => this.responseError(error))

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
